import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function updateOrganization(id, payload) {
  try {
    const response = await authFetch(`${BACKEND_URL}/organization/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
      code: data?.code ?? "",
    };
  } catch (error) {
    console.error("[updateOrganization] failed:", error);
    return {
      success: false,
      message: "조직 설정 저장 중 오류가 발생했습니다.",
      data: null,
      code: "NETWORK_ERROR",
    };
  }
}
